import { Action } from "./Action";
import { ActionCentre } from "./ActionCentre";
import { Actions, IAction, IPopupSettings } from "./types";

declare var _gaq: any;

export class OfferPopup {
    private actionCentre: ActionCentre;
    private settings: IPopupSettings;
    private isSmartFooter: boolean;
    private smartFooterElements: string[] = ["Airport Lounges", "Meet And Greet", "Sightseeing", "Best Tours In The World"];

    constructor(actionsService: ActionCentre, settings: IPopupSettings, isSmartFooter?: boolean) {
        this.actionCentre = actionsService;
        this.settings = settings;
        this.isSmartFooter = isSmartFooter || false;

        this.runBindings();
    }

    private runBindings(): void {
        const query: string = `[${this.settings.offerUniqueSelector}]`;
        const offersSelector: string = `[${this.settings.offerStageSelector}] ${query}`;
        const offers: NodeListOf<HTMLElement> = document.querySelectorAll(offersSelector) as NodeListOf<HTMLElement>;
        const offerPopupContainerSelector: string = `[data-offer-popup-container="${this.settings.sliderId}"]`;
        const offerPopupContainer: HTMLElement = document.querySelector(offerPopupContainerSelector) as HTMLElement;

        for (let i = 0; i < offers.length; i++) {
            offers[i].addEventListener("click", (e) => {
                if (this.isSmartFooter) {
                    _gaq.push(["_trackEvent", "Interaction", `View Footer Popup (${this.smartFooterElements[i]})`, document.URL, 0, false]);
                }

                e.stopPropagation();
                const showAction = new Action(Actions.SHOW_OVERLAY, ["showOverlay", true]);
                this.actionCentre.Do(showAction);

                const offerId: number = parseInt(offers[i].getAttribute(this.settings.offerUniqueSelector), 10);
                const popupQuery: string = `[${this.settings.offerUniqueSelector} = "${offerId}"] .offer__popup`;
                const offerPopup: HTMLElement = document.querySelector(popupQuery) as HTMLElement;

                offerPopupContainer.innerHTML = offerPopup.outerHTML;
                offerPopupContainer.style.display = "block";      

                const closeSelector: string = `[data-offer-popup-container="${this.settings.sliderId}"] [data-close-offer-popup]`;
                const close: HTMLElement = document.querySelector(closeSelector) as HTMLElement;
                close.onclick = (evt) => {
                    evt.stopPropagation();
                    const hideAction = new Action(Actions.HIDE_OVERLAY, ["showOverlay", false]);
                    this.actionCentre.Do(hideAction);

                    offerPopupContainer.innerHTML = "";
                    offerPopupContainer.style.display = "none";      
                };

                offerPopupContainer.onclick = (evt) => {
                    evt.stopPropagation();
                };
            });
        }

        const overlay: HTMLElement = document.querySelector("[data-overlay]") as HTMLElement;

        overlay.addEventListener("click", (e) => {
            const hideAction = new Action(Actions.HIDE_OVERLAY, ["showOverlay", false]);
            this.actionCentre.Do(hideAction);

            offerPopupContainer.innerHTML = "";
            offerPopupContainer.style.display = "none";                
        });
    }
}



// WEBPACK FOOTER //
// ./src/global/OfferPopup.ts